import { customReports } from "../../constants/actionTypes";

const getCustomFiltersList = () => {
  return {
    type: customReports.GET_CUSTOM_FILTER_REQUEST,
  };
};
const getCustomFiltersListSuccess = (data) => ({
  type: customReports.GET_CUSTOM_FILTER_SUCCESS,
  payload: data,
});
const getCustomFiltersListFailure = (error) => ({
  type: customReports.GET_CUSTOM_FILTER_FAILURE,
  payload: error,
});

const getCustomReports = (urlParams, data) => ({
  type: customReports.GET_CUSTOM_REPORT_REQUEST,
  payload: { urlParams, data },
});
const getCustomReportsSuccess = (data) => ({
  type: customReports.GET_CUSTOM_REPORT_SUCCESS,
  payload: data,
});
const getCustomReportsReset = () => ({
  type: customReports.GET_CUSTOM_REPORT_RESET,
});
const getCustomReportsAllData = (urlParams, data) => ({
  type: customReports.GET_CUSTOM_REPORT_REQUEST_ALL_DATA,
  payload: { urlParams, data },
});
const getCustomReportsAllDataSuccess = (data) => ({
  type: customReports.GET_CUSTOM_REPORT_ALL_DATA_SUCCESS,
  payload: data,
});
const getCustomReportsFailure = (error) => ({
  type: customReports.GET_CUSTOM_REPORT_FAILURE,
  payload: error,
});

export {
  getCustomReports,
  getCustomFiltersList,
  getCustomFiltersListSuccess,
  getCustomFiltersListFailure,
  getCustomReportsSuccess,
  getCustomReportsReset,
  getCustomReportsAllData,
  getCustomReportsAllDataSuccess,
  getCustomReportsFailure,
};
